import Link from 'next/link';
import React, { useEffect, useState } from 'react'
import { IoIosArrowDown } from 'react-icons/io'

const FrequentQuestions = ({ FaqTableData, heading }) => {
   const [viewAll, setViewAll] = useState(false);
   const [showAns, setShowAns] = useState({ key: "", status: false });
   const [showAtRender, setShowAtRender] = useState(true);

   useEffect(() => {
      const timer = setTimeout(() => {
         setShowAtRender(false);
      }, 2000);

      return () => clearTimeout(timer);
   }, []);

   const handleScroll = (e) => {
      e.preventDefault();
      const href = e.currentTarget.href;
      const targetId = href.replace(/.*\#/, "");
      const elem = document.getElementById(targetId);
      elem?.scrollIntoView({
         behavior: "smooth",
      });
   };


   const initialFAQsCount = 5;
   const displayedFAQs = viewAll ? FaqTableData : FaqTableData.slice(0, initialFAQsCount);

   return (
      <div style={{ margin: "4rem 2rem", display: "flex", flexDirection: "column", alignItems: "center" }} id="faq-section">
         <div style={{ width: "fit-content", margin: "auto" }}><h3 style={{ font: "normal normal bold 2.2rem/3rem Inter" }}>{heading}</h3></div>
         <div style={{ width: "60%" }}>
            {
               displayedFAQs?.map((ele, idx) => {
                  return (
                     <div key={ele?.id}>

                        <div style={{ padding: "2rem 1rem 1rem 1rem", borderBottom: "1px solid #ececec", backgroundColor: "white" }}>
                           <div style={{ display: "flex", justifyContent: "space-between", gap: "5rem", cursor: "pointer", color: "#101828", font: "normal normal 500 1.8rem/2.2rem" }} onClick={() => setShowAns({ key: ele?.id, status: showAns?.key === ele?.id ? !showAns?.status : true })}>
                              <p style={{ color: "#626060", marginBottom: "0", font: "normal normal 500 1.6rem/2.4rem Inter" }}>{ele?.para}</p>
                              <span style={{ color: "#2a6ab4", fontSize: "1.8rem", }}><IoIosArrowDown /></span>
                           </div>
                           <div
                              style={
                                 // { color: "#475467", , font: "normal normal normal 1.6rem/2rem Inter" }
                                 showAns?.key === ele?.id && showAns?.status ? {
                                    color: "#475467", maxHeight: "40rem", transition: "all 0.3s", paddingTop: "1rem", marginRight: "3rem"
                                 } : {
                                    color: "#475467", maxHeight: "0rem", transition: "all 0.3s", marginRight: "3rem", display: "none"
                                 }
                              }
                           >
                              {
                                 ((showAns?.key === ele?.id && showAns?.status) || showAtRender) ? ele?.des : ""
                              }
                           </div>
                        </div>
                     </div>
                  )
               })
            }
         </div>
         <Link href='#faq-section' onClick={(e) => handleScroll(e)} style={{ textDecoration: "none" }}><p style={{ color: "#2a6ab4", cursor: "pointer", marginTop: "3rem", font: "normal normal 500 1.6rem/2rem Inter" }} onClick={() => setViewAll(!viewAll)}>{viewAll ? 'View Less' : 'View More'}</p></Link>
      </div>
   )
}

export default FrequentQuestions

// className="my-10 mx-4 flex flex-col items-center wrapper sm:mx-40 sm:mt-20"
// className="w-fit m-auto" 
// className="text-lg font-bold sm:text-2xl sm:mb-10"
//  className="w-full sm:w-[70%]" 
// className="py-6 px-2 border-b-2 border-slate-100 bg-white"
// className="flex justify-between gap-10 cursor-pointer text-[#101828] text-base font-semibold"
// className="text-[#626060]"
// className={` text-blue font-lg ${showAns?.key === ele?.id && showAns?.status ? 'rotate-180 duration-300' : 'rotate-0 duration-300'}`}
// className={` text-[#475467] mr-10 text-base ${showAns?.key === ele?.id && showAns?.status ? 'max-h-40 duration-300 transition-all pt-6' : 'max-h-0 duration-300 transition-all'}`} 
// className="text-blue cursor-pointer mt-6 text-lg font-medium"